import config from '../../../../config';
import { productEnable, productDisable } from '../disable/DisableActions';
import { productUpdate } from '../update/UpdateActions';
import ProductsServiceClient from '../../../../clients/ProductsService/ProductsServiceClient';

const getQuantityUpdateMeta = (quantity) => ({
  ga: {
    cat: config.gaCat,
    act: 'TileActions',
    lab: `Qty_${quantity}`,
  },
});

export const quantityUpdate = (id, projectId, quantity, baseApiUrl) => {
  return (dispatch) => {
    dispatch(productDisable(id));
    ProductsServiceClient.updateQuantity(baseApiUrl, projectId, id, parseInt(quantity, 10))
      .then((product) => {
        dispatch(productUpdate(product, getQuantityUpdateMeta(quantity)));
        return dispatch(productEnable(id));
      })
      .catch(() => dispatch(productEnable(id)));
  };
};
